import React, { Component } from 'react';
import { CardImg, CardTitle } from 'reactstrap';
// import { Container, Row, Col } from 'reactstrap';
import { Row, Col } from "antd";
import wai_sandee from "../../assets/feednews/wai_sandee.png";
import logo_itone from "../../assets/feednews/logo_itone.png";
import guide_book from "../../assets/feednews/guide_book.png";
import teamwork_samard from "../../assets/feednews/teamwork_samard.png";


// const setStyleBoxSizing = {height:"586px"};
export default class FeedNews extends Component {

    render() {
        return (
            <div className='cardfeednews' >
                <Row className='feedNews'>
                    FEED NEWS
                </Row>
                <Row className="articleStyle">
                    <Col
                        lg={{ span: 8 }}
                        xl={{ span: 8 }}
                    >
                        <CardImg src={logo_itone}
                            className='imageStyle' />
                    </Col>
                    <Col
                        lg={{ span: 16 }}
                        xl={{ span: 16 }}
                    >
                        <CardTitle className='titleNameStyle'>
                            IT One Announcement
                            <p className='textStyle'>
                                ข่าวสารจาก บริษัท IT One
                            </p>
                            <div className='readMore' >
                                <a href="https://scg.service-now.com/myrequestscg" rel="noopener noreferrer" target="_blank">
                                    Read More
                                </a>
                            </div>
                        </CardTitle>
                        <br />
                    </Col>
                </Row>
                <Row className="articleStyle">
                    <Col
                        lg={{ span: 8 }}
                        xl={{ span: 8 }}
                    >
                        <CardImg src={guide_book}
                            className='imageStyle' />
                    </Col>
                    <Col
                        lg={{ span: 16 }}
                        xl={{ span: 16 }}
                    >
                        <CardTitle className='titleNameStyle'>
                            SANDEE User Manual
                            <p className='textStyle'>
                                วิธีการ Unlock & Reset

                            </p>
                            <div className='readMore' >
                                <a href="https://scg.service-now.com/myrequestscg?id=u_kb_article&sys_id=92ab3ba4db241450c48ef0eb0c9619b1" rel="noopener noreferrer" target="_blank">
                                    Read More
                                </a>
                            </div>
                        </CardTitle>

                        <br />
                    </Col>
                </Row>
            </div>
        )
    }
}
